export const COOKIES_ADBLOCK = 'fontanka_a_template';
export const AB_YANDEX_ADBLOCK_COOKIE = 'fontanka_ab_proxy_v0';
